import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { Assignation } from '../../../context/types'
import { isLandscape, isMobilePortrait } from '../../../utils'
import { SortableRankingStm } from './SortableRankingStm'
import { Droppable } from './Dnd/Droppable'
import { isArabic } from '../../../i18n/useTranslation'
import { useCtxParams } from '../../../context/useCommonCtx'

type Props = {
    id: string
    title?: string
    items: Assignation[]
    disabled?: boolean
    bgColor?: string
    isWarning?: boolean
}

export const StmList = ({
    id,
    title,
    items,
    disabled = false,
    bgColor = 'lightgray',
    isWarning = false,
}: Props) => {
    // Create sortable IDs for the items in this container
    const sortableIds = items.map((item) => String(item.valueKey))

    const params = useCtxParams()

    return (
        // flex or grid container, the default min-height for children is auto
        // = as tall as their content >< overflow
        // min-h-0 = children will shrink to available space, even if content is taller
        // Was: min-h-0
        <div
            className="flex flex-col h-full"
            style={{ direction: isArabic(params) ? 'rtl' : 'ltr' }}
        >
            {title && (
                <h3
                    style={{
                        color: isWarning ? 'red' : 'inherit',
                    }}
                    className={`text-sm font-bold my-0 text-center rounded`}
                >
                    {title}
                </h3>
            )}
            <Droppable
                as="div"
                id={id}
                data={{ sourceContainerId: id }}
                className={`flex-1 space-y-1 p-1 rounded`}
                isOverClassName={`bg-gray-100`}
                // Was: min-h-0 overflow-y-auto
                style={bgColor ? { backgroundColor: bgColor } : {}}
            >
                <SortableContext
                    items={sortableIds}
                    strategy={verticalListSortingStrategy}
                >
                    {items.length > 0 ? (
                        items.map((stm) => (
                            <SortableRankingStm
                                key={stm.valueKey}
                                stm={stm}
                                compact
                                landscape={isLandscape()}
                                sourceContainerId={id}
                                withIcon={!isMobilePortrait()} // FIXME reactive?
                            />
                        ))
                    ) : (
                        <div className="text-center text-gray-500">-</div>
                    )}
                </SortableContext>
            </Droppable>
        </div>
    )
}
